// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'building-globe';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.658 1.875a8.625 8.625 0 1 0-2.27 15.854m-10.18-5.51h9.348m-9.348-5.75h9.348m5.257-.845a.662.662 0 0 1 .718-.593h2.875a.662.662 0 0 1 .719.593v2.645h-4.313Zm2.155-.593v-3.45m1.437 10.005H16.53m2.875 3.484H16.53m2.875 3.495H16.53' />
    <path d='M7.482.921a27.938 27.938 0 0 0 .651 16.962M11.203.921a27.896 27.896 0 0 1 .733 3.487M22.28 22.281H.958m12.697 0h8.625V8.721a.47.47 0 0 0-.479-.453h-7.667a.47.47 0 0 0-.479.453Z' />
  </g>
);

export const viewBox = '-0.5 -0.5 24 24';
